export default __webpack_public_path__ + "static/media/Jobvious_logo@2x.cb858886.svg";